export const TWILIO_GET_TWILIO_SETTINGS_START = 'TWILIO_GET_TWILIO_SETTINGS_START';
export const TWILIO_GET_TWILIO_SETTINGS_SUCCESS = 'TWILIO_GET_TWILIO_SETTINGS_SUCCESS';
export const TWILIO_GET_TWILIO_SETTINGS_FAIL = 'TWILIO_GET_TWILIO_SETTINGS_FAIL';

export const TWILIO_SAVE_TWILIO_ACCOUNT_SETTINGS_START = 'TWILIO_SAVE_TWILIO_ACCOUNT_SETTINGS_START';
export const TWILIO_SAVE_TWILIO_ACCOUNT_SETTINGS_SUCCESS = 'TWILIO_SAVE_TWILIO_ACCOUNT_SETTINGS_SUCCESS';
export const TWILIO_SAVE_TWILIO_ACCOUNT_SETTINGS_FAIL = 'TWILIO_SAVE_TWILIO_ACCOUNT_SETTINGS_FAIL';

export const TWILIO_REMOVE_TWILIO_ACCOUNT_START = 'TWILIO_REMOVE_TWILIO_ACCOUNT_START';
export const TWILIO_REMOVE_TWILIO_ACCOUNT_SUCCESS = 'TWILIO_REMOVE_TWILIO_ACCOUNT_SUCCESS';
export const TWILIO_REMOVE_TWILIO_ACCOUNT_FAIL = 'TWILIO_REMOVE_TWILIO_ACCOUNT_FAIL';

export const TWILIO_GET_ALL_TWILIO_PHONES_START = 'TWILIO_GET_ALL_TWILIO_PHONES_START';
export const TWILIO_GET_ALL_TWILIO_PHONES_SUCCESS = 'TWILIO_GET_ALL_TWILIO_PHONES_SUCCESS';
export const TWILIO_GET_ALL_TWILIO_PHONES_FAIL = 'TWILIO_GET_ALL_TWILIO_PHONES_FAIL';

export const TWILIO_SET_ALL_TWILIO_PHONES = 'TWILIO_SET_ALL_TWILIO_PHONES';

export const TWILIO_GET_TWILIO_ASSIGNED_AGENTS_START = 'TWILIO_GET_TWILIO_ASSIGNED_AGENTS_START';
export const TWILIO_GET_TWILIO_ASSIGNED_AGENTS_SUCCESS = 'TWILIO_GET_TWILIO_ASSIGNED_AGENTS_SUCCESS';
export const TWILIO_GET_TWILIO_ASSIGNED_AGENTS_FAIL = 'TWILIO_GET_TWILIO_ASSIGNED_AGENTS_FAIL';

export const TWILIO_SET_TWILIO_ASSIGNED_AGENTS = 'TWILIO_SET_TWILIO_ASSIGNED_AGENTS';

export const TWILIO_SAVE_TWILIO_ASSIGNED_AGENTS_START = 'TWILIO_SAVE_TWILIO_ASSIGNED_AGENTS_START';
export const TWILIO_SAVE_TWILIO_ASSIGNED_AGENTS_SUCCESS = 'TWILIO_SAVE_TWILIO_ASSIGNED_AGENTS_SUCCESS';
export const TWILIO_SAVE_TWILIO_ASSIGNED_AGENTS_FAIL = 'TWILIO_SAVE_TWILIO_ASSIGNED_AGENTS_FAIL';
